import { Button, Col, Form, Modal, notification, Row, Select } from "antd";
import { useTranslation } from "react-i18next";

import { useUpdateLandwirtMutation } from "store/masterdata";
import { UpdateLandwirtParams } from "types/masterdata.types";

interface Props {
  initialValues: {
    id?: number;
    language?: number;
  };
  visible: boolean;
  onClose(): void;
  onSuccess(): void;
}

function LWLanguageForm({
  initialValues,
  visible,
  onClose,
  onSuccess,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const [landwirtForm] = Form.useForm();

  const [updateLandwirt, updateLandwirtResult] = useUpdateLandwirtMutation();

  const handleLandwirtFormSubmit = async (values: UpdateLandwirtParams) => {
    try {
      const payload = await updateLandwirt({
        id: initialValues.id,
        ...values,
      }).unwrap();

      if (!payload.hasErrors) {
        notification.success({
          message: t("masterdata.lw_details.change_language_success"),
        });
        onSuccess();
        onClose();
      } else {
        notification.error({ message: payload.errorDetails.errorMessage });
      }
    } catch (error) {
      console.error("Error", error);
      onClose();
    }
  };

  const langOptions = [0, 1, 2].map((option) => ({
    label: t(`masterdata.enums.LanguageEnum.${option}`),
    value: option,
  }));

  return (
    <Modal
      footer={null}
      title={t("masterdata.lw_details.change_language")}
      visible={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="landwirt-form"
        form={landwirtForm}
        onFinish={handleLandwirtFormSubmit}
        layout="vertical"
        initialValues={initialValues}
      >
        <Form.Item
          name="language"
          label={t("masterdata.lw_details.language_farmer")}
          rules={[{ required: true }]}
        >
          <Select options={langOptions} />
        </Form.Item>
        <Row gutter={20}>
          <Col span={12}>
            <Button onClick={onClose} block>
              {t("discard")}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              loading={updateLandwirtResult.isLoading}
              block
            >
              {t("save_changes")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default LWLanguageForm;
